<script setup lang="ts">
import CiSkeletonItem from '@/components/skeleton/CiSkeletonItem.vue';
</script>

<template>
  <CiSkeletonItem class="skeleton__headline mx-auto mb-4 block h-[30px] w-2/5" />
  <div class="flex gap-3">
    <CiSkeletonItem class="block h-[295px] w-full md:w-1/2 lg:w-4/12" />
    <CiSkeletonItem class="hidden h-[295px] md:block md:w-1/2 lg:w-4/12" />
    <CiSkeletonItem class="hidden h-[295px] lg:block lg:w-4/12" />
  </div>
</template>
